<h3 class="card-title">Payroll Audit Log</h3>
<div>
  <table id="payroll-audit-log-table" class="table">
    <thead>
      <tr>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'DateChanged'); search()">
          Date/time changed
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'PayDate'); search()">
          Pay Date
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'PeriodEndDate'); search()">
          Period End Date
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'SequenceNumber'); search()">
          Sequence Number
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'PayrollSchedule'); search()">
          Payroll Schedule
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'Description'); search()">
          Information changed
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'payroll-audit-log-table', 'ChangedBy'); search()">
          Changed by
        </th>
      </tr>
      <tr class="filter-row">
        <th></th>
        <th>
          <input
            [(ngModel)]="searchConfig.PayDate"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="searchConfig.PeriodEndDate"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="searchConfig.SequenceNumber"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="searchConfig.PayrollSchedule"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="searchConfig.Description"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="searchConfig.ChangedBy"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
      </tr>
    </thead>
    <tbody *ngIf="payload && payload.Items && payload.Items.length">
      <tr *ngFor="let row of payload.Items; let i = index">
        <td>{{ row.DateChanged | date: 'MM/dd/yyyy h:mma' }}</td>
        <td>{{ row.PayDate | date: 'MM/dd/yyyy' }}</td>
        <td>{{ row.PeriodEndDisplay }}</td>
        <td>{{ row.SequenceNumber }}</td>
        <td>{{ row.PayrollSchedule }}</td>
        <td class="text-wrap">
          <div [ngClass]="{ 'line-clamp': !showMore[i] }" (click)="showMore[i] = !showMore[i]">
            {{ row.Description }}
          </div>
        </td>
        <td>{{ row.ChangedBy }}</td>
      </tr>
    </tbody>
    <tbody *ngIf="!payload || !payload.Items || !payload.Items.length">
      <tr>
        <td colspan="6" class="sub-row">
          <em>No results found</em>
        </td>
      </tr>
    </tbody>
  </table>
  <lib-pagination
    *ngIf="payload && payload.Pagination"
    [pagination]="payload.Pagination"
    (pageChanged)="loadPage($event)"></lib-pagination>
</div>
